/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ImportedKpiAction = {
    Created: 'created',
    Reused: 'reused',
    Versioned: 'versioned'
} as const;
export type ImportedKpiAction = typeof ImportedKpiAction[keyof typeof ImportedKpiAction];

